import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD2wUP9-6qaULBy_TQRl04kO0pYCwMWrSs",
  authDomain: "cupiprod-51cbd.firebaseapp.com",
  projectId: "cupiprod-51cbd",
  storageBucket: "cupiprod-51cbd.firebasestorage.app",
  messagingSenderId: "150905613673",
  appId: "1:150905613673:web:6eddb1d6dff8016dfbe1f8",
  measurementId: "G-NS7BRCLY3L"
};


// Initialize only once
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export so any file can use it
export { analytics };